"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _Typography = _interopRequireDefault(require("@mui/material/Typography"));
var _styles = require("@mui/styles");
var _linkifyReact = _interopRequireDefault(require("linkify-react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _Flex = _interopRequireDefault(require("./Flex"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * Abstraction of Material UI's `Typography` that supports multiple 
 * strings and renders within one of our `Flex` containers by default
 * 
 * Original author @heron-web/material (no longer maintained)
 */const String = props => {
  const useStyles = (0, _styles.makeStyles)({
    root: {}
  });
  const classes = useStyles();

  /**
   * Get the style object to apply to `Typography` instances.
   * 
   * @return {Object}
   */
  const getStringStyles = () => {
    const styles = {
      display: props.inline ? "inline" : undefined,
      lineHeight: props.lineHeight,
      whiteSpace: props.whiteSpace,
      wordBreak: "break-word",
      ...props.style
    };
    if (props.bold) {
      styles.fontWeight = "bold";
    }
    if (props.centre) {
      styles.textAlign = "center";
    }
    if (props.lineClamp) {
      styles.display = "-webkit-box";
      styles.overflow = "hidden";
      styles.textOverflow = "ellipsis";
      styles.WebkitBoxOrient = "vertical";
      styles.WebkitLineClamp = props.lineClamp || 1;
    }
    if (props.selectable) {
      styles.userSelect = "text";
    }
    return styles;
  };
  const stringStyles = getStringStyles();

  /**
   * Get our strings array.
   * 
   * @return {Array}
   */
  const getStrings = () => {
    const str = props.str;
    const strs = Array.isArray(str) ? str : [str];
    return strs.map(s => s?.toString().replace(/\r/g, "").split("\n")).flat().map(s => !props.noTrim ? s?.trim() : s).filter(s => s);
  };
  const strings = getStrings();

  /**
   * Render the Flex container.
   *
   * @param {Array<String>} strings Strings to render
   * @return {ReactNode}
   */
  const renderFlex = strings => {
    return /*#__PURE__*/(0, _jsxRuntime.jsx)(_linkifyReact.default, {
      options: props.linkOptions,
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Flex.default, {
        ...props.FlexProps,
        className: props.classNameFlex,
        gap: props.gap,
        title: props.title,
        children: renderStrings(strings)
      })
    });
  };

  /**
   * Render our strings as `Typography` instances.
   *
   * @param {Array<String>} strings Strings to render
   * @return {ReactNode}
   */
  const renderStrings = strings => {
    return strings.map((string, key) => /*#__PURE__*/(0, _jsxRuntime.jsx)(_Typography.default, {
      color: props.color,
      className: `${classes.root} ${props.classNameTypography}`,
      component: props.component,
      style: stringStyles,
      sx: {
        color: props.colorNamed
      },
      title: props.noFlex ? props.title : undefined,
      variant: props.variant,
      ...props.TypographyProps,
      children: string
    }, key));
  };
  if (!strings.length) return null;else return !props.noFlex && !props.inline ? renderFlex(strings) : renderStrings(strings);
};
String.propTypes = {
  FlexProps: _propTypes.default.object,
  TypographyProps: _propTypes.default.object,
  bold: _propTypes.default.bool,
  centre: _propTypes.default.bool,
  classNameFlex: _propTypes.default.string,
  classNameTypography: _propTypes.default.string,
  color: _propTypes.default.oneOf(["inherit", "primary", "secondary", "success", "error", "info", "warning", "textPrimary", "textSecondary", "textDisabled"]),
  colorNamed: _propTypes.default.string,
  component: _propTypes.default.string,
  gap: _propTypes.default.number,
  inline: _propTypes.default.bool,
  lineClamp: _propTypes.default.number,
  lineHeight: _propTypes.default.string,
  linkOptions: _propTypes.default.object,
  noFlex: _propTypes.default.bool,
  noTrim: _propTypes.default.bool,
  selectable: _propTypes.default.bool,
  str: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number, _propTypes.default.array]),
  style: _propTypes.default.object,
  title: _propTypes.default.string,
  variant: _propTypes.default.oneOf(["body1", "body2", "button", "caption", "h1", "h2", "h3", "h4", "h5", "h6", "inherit", "overline", "subtitle1", "subtitle2"]),
  whiteSpace: _propTypes.default.string
};
String.defaultProps = {
  bold: false,
  centre: false,
  color: "inherit",
  gap: 1,
  inline: false,
  noFlex: false,
  noTrim: false,
  selectable: false,
  variant: "body1"
};
var _default = exports.default = String;